The privacy consent component this is responding to.
